import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router, Routes, RouterModule } from '@angular/router';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxSmartModalService } from 'ngx-smart-modal';
@Component({
  selector: 'app-subscribe-otp',
  templateUrl: './subscribe-otp.component.html',
  styleUrls: ['./subscribe-otp.component.scss']
})
export class SubscribeOtpComponent implements OnInit {
  profileData: any=[];
  profileID = '';
  newUserStatus = '';
  errorAlert: boolean = false;
  constructor(public ngxSmartModalService: NgxSmartModalService, private route: ActivatedRoute, public http: HttpClient, private router: Router) {}
  loaded:boolean = false;

  submitOTP() {
    this.route.params.subscribe(params2 => {
      this.subscriptionStatusId = params2['otpID'];
    this.newUserStatus = params2['needsReset'];
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
      this.http.get('https://staging.videyo.tv/billing/subscribeOtp?otp='+this.otp+'&id='+this.subscriptionStatusId, {
        headers: myheader
    })
  .subscribe(
    res => {
      if (this.newUserStatus == 'reset') {
      this.router.navigate(['/set-password']);
      }
      else { 
       this.router.navigate(['/']);
      }
   },
    error => {
      this.errorAlert = true;
    }
  );
  });
}
submitOTPFake() {
  this.route.params.subscribe(params2 => {
    this.subscriptionStatusId = params2['otpID'];
    this.newUserStatus = params2['needsReset'];
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
    this.http.get('https://staging.videyo.tv/billing/subscribeOtpFake?otp='+this.otp+'&id='+this.subscriptionStatusId, {
      headers: myheader
  })
.subscribe(
  res => {
     if (this.newUserStatus == 'reset') {
     this.router.navigate(['/set-password']);
     }
     else { 
      this.router.navigate(['/']);
     }
  },
  error => {
    this.router.navigate(['/login']);
    console.log('ERROR:');
    console.log(error);
  }
);
});
}
  subscribeOTP:any;
  subscriptionStatusId:any;
  otp: string = '';
  
  onOTPKeyUp(event: any) {
    this.otp = event.target.value;
  }

  ngOnInit() {
    
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.loaded = true;
    }, 1500);
  }

}
